/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShipmentState } from "./ShipmentState";
import {
  ShipmentStateFromJSON,
  ShipmentStateFromJSONTyped,
  ShipmentStateToJSON,
  ShipmentStateToJSONTyped,
} from "./ShipmentState";
import type { CountryCode } from "./CountryCode";
import {
  CountryCodeFromJSON,
  CountryCodeFromJSONTyped,
  CountryCodeToJSON,
  CountryCodeToJSONTyped,
} from "./CountryCode";

/**
 *
 * @export
 * @interface IndivualShipmentLine
 */
export interface IndivualShipmentLine {
  /**
   *
   * @type {string}
   * @memberof IndivualShipmentLine
   */
  shipmentId: string;
  /**
   *
   * @type {string}
   * @memberof IndivualShipmentLine
   */
  pickupDate: string;
  /**
   *
   * @type {boolean}
   * @memberof IndivualShipmentLine
   */
  booked: boolean;
  /**
   *
   * @type {ShipmentState}
   * @memberof IndivualShipmentLine
   */
  status: ShipmentState;
  /**
   *
   * @type {string}
   * @memberof IndivualShipmentLine
   */
  pickupCity: string;
  /**
   *
   * @type {string}
   * @memberof IndivualShipmentLine
   */
  pickupStateOrProvince: string;
  /**
   *
   * @type {string}
   * @memberof IndivualShipmentLine
   */
  pickupPostalCode: string;
  /**
   *
   * @type {CountryCode}
   * @memberof IndivualShipmentLine
   */
  pickupCountryCode: CountryCode;
  /**
   *
   * @type {string}
   * @memberof IndivualShipmentLine
   */
  deliveryCity: string;
  /**
   *
   * @type {string}
   * @memberof IndivualShipmentLine
   */
  deliveryStateOrProvince: string;
  /**
   *
   * @type {string}
   * @memberof IndivualShipmentLine
   */
  deliveryPostalCode: string;
  /**
   *
   * @type {CountryCode}
   * @memberof IndivualShipmentLine
   */
  deliveryCountryCode: CountryCode;
  /**
   *
   * @type {string}
   * @memberof IndivualShipmentLine
   */
  weight: string;
}

/**
 * Check if a given object implements the IndivualShipmentLine interface.
 */
export function instanceOfIndivualShipmentLine(
  value: object,
): value is IndivualShipmentLine {
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (!("pickupDate" in value) || value["pickupDate"] === undefined)
    return false;
  if (!("booked" in value) || value["booked"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("pickupCity" in value) || value["pickupCity"] === undefined)
    return false;
  if (
    !("pickupStateOrProvince" in value) ||
    value["pickupStateOrProvince"] === undefined
  )
    return false;
  if (!("pickupPostalCode" in value) || value["pickupPostalCode"] === undefined)
    return false;
  if (
    !("pickupCountryCode" in value) ||
    value["pickupCountryCode"] === undefined
  )
    return false;
  if (!("deliveryCity" in value) || value["deliveryCity"] === undefined)
    return false;
  if (
    !("deliveryStateOrProvince" in value) ||
    value["deliveryStateOrProvince"] === undefined
  )
    return false;
  if (
    !("deliveryPostalCode" in value) ||
    value["deliveryPostalCode"] === undefined
  )
    return false;
  if (
    !("deliveryCountryCode" in value) ||
    value["deliveryCountryCode"] === undefined
  )
    return false;
  if (!("weight" in value) || value["weight"] === undefined) return false;
  return true;
}

export function IndivualShipmentLineFromJSON(json: any): IndivualShipmentLine {
  return IndivualShipmentLineFromJSONTyped(json, false);
}

export function IndivualShipmentLineFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): IndivualShipmentLine {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"],
    pickupDate: json["pickupDate"],
    booked: json["booked"],
    status: ShipmentStateFromJSON(json["status"]),
    pickupCity: json["pickupCity"],
    pickupStateOrProvince: json["pickupStateOrProvince"],
    pickupPostalCode: json["pickupPostalCode"],
    pickupCountryCode: CountryCodeFromJSON(json["pickupCountryCode"]),
    deliveryCity: json["deliveryCity"],
    deliveryStateOrProvince: json["deliveryStateOrProvince"],
    deliveryPostalCode: json["deliveryPostalCode"],
    deliveryCountryCode: CountryCodeFromJSON(json["deliveryCountryCode"]),
    weight: json["weight"],
  };
}

export function IndivualShipmentLineToJSON(json: any): IndivualShipmentLine {
  return IndivualShipmentLineToJSONTyped(json, false);
}

export function IndivualShipmentLineToJSONTyped(
  value?: IndivualShipmentLine | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    pickupDate: value["pickupDate"],
    booked: value["booked"],
    status: ShipmentStateToJSON(value["status"]),
    pickupCity: value["pickupCity"],
    pickupStateOrProvince: value["pickupStateOrProvince"],
    pickupPostalCode: value["pickupPostalCode"],
    pickupCountryCode: CountryCodeToJSON(value["pickupCountryCode"]),
    deliveryCity: value["deliveryCity"],
    deliveryStateOrProvince: value["deliveryStateOrProvince"],
    deliveryPostalCode: value["deliveryPostalCode"],
    deliveryCountryCode: CountryCodeToJSON(value["deliveryCountryCode"]),
    weight: value["weight"],
  };
}
